export type ScrapingUrlValidationError = 'required' | 'invalid';

export function normalizeScrapingUrl(value: string): string {
  const trimmed = value.trim();
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
}

export function validateScrapingUrl(
  value: string
):
  | { ok: true; url: string }
  | { ok: false; reason: ScrapingUrlValidationError } {
  const trimmed = value.trim();
  if (!trimmed) return { ok: false, reason: 'required' };

  const normalized = normalizeScrapingUrl(trimmed);

  try {
    const parsed = new URL(normalized);
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
      return { ok: false, reason: 'invalid' };
    }
    if (!parsed.hostname || !parsed.hostname.includes('.')) {
      return { ok: false, reason: 'invalid' };
    }

    return { ok: true, url: normalized };
  } catch {
    return { ok: false, reason: 'invalid' };
  }
}

export function getScrapingUrlValidationMessage(
  reason: ScrapingUrlValidationError,
  messages: { url_required: string; url_invalid: string }
): string {
  if (reason === 'required') return messages.url_required;
  return messages.url_invalid;
}
